import {TData, TPayload} from 'src/components/List';
import {TItemId} from 'src/constants';
import {rootApi} from 'src/models';

import {TFilters, TMessageMatcherPreset, TMessageMatcherPresetForm} from './definitions';
import {prepareDataForSave} from './utils';

export const presetsApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getMessageMatcherPresets: builder.query<TData<TMessageMatcherPreset>, TPayload<TFilters>>({
      query: (data) => ({
        method: 'POST',
        url: '/message-matcher/preset/list',
        data,
      }),
    }),
    getMessageMatcherPreset: builder.query<TMessageMatcherPreset, TItemId>({
      query: (id) => ({
        method: 'GET',
        url: `/message-matcher/preset/${id}`,
        meta: {isShowError: true},
      }),
    }),
    getMessageMatcherPresetTopics: builder.query<string[], void>({
      query: () => ({
        method: 'GET',
        url: '/message-matcher/preset/topics',
      }),
    }),
    getMessageMatcherPresetIndustries: builder.query<string[], void>({
      query: () => ({
        method: 'GET',
        url: '/message-matcher/preset/industries',
      }),
    }),
    registerMessageMatcherPreset: builder.mutation<
      void,
      {data: TMessageMatcherPresetForm; presetId: number}
    >({
      query: ({data, presetId}) => ({
        method: 'POST',
        url: `/message-matcher/preset/${presetId}/create-and-register-message-matcher`,
        data: prepareDataForSave(data),
        meta: {isShowError: true},
      }),
    }),
  }),
});

export const {
  useGetMessageMatcherPresetsQuery,
  useGetMessageMatcherPresetQuery,
  useGetMessageMatcherPresetTopicsQuery,
  useGetMessageMatcherPresetIndustriesQuery,
  useRegisterMessageMatcherPresetMutation,
} = presetsApi;
